import axios from "axios";
import * as actionType from "../../../constant/actionType";
// import { fetchData,fetchDataSuccess, fetchDataError } from "../../redux/classes/client-portal/clientCsvSlice";
export const UpdateProviderPaymentResponsibility =
  (ApiData, ipAddress) => async (dispatch) => {
    try {
      const response = await axios({
        method: "patch",
        data: ApiData,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
          userip: ipAddress,
        },
        url: `${actionType.environment_url}/api/admin/provider/UpdateProviderPaymentResponsibility`,
      });
      return response.data;
    } catch (error) {
      return error.message;
    }
  };
